import { useQuery } from '@tanstack/react-query'
import { axiosGet } from 'Redux/axiosHelper'
import {
  LeagueAnalytics,
  LeagueAnalyticsParams,
} from 'types/league/leagueAnalytics'

export type { LeagueAnalytics, LeagueAnalyticsParams } from 'types/league/leagueAnalytics'

const getLeagueAnalytics = async (params: LeagueAnalyticsParams): Promise<LeagueAnalytics> => {
  const { leagueId, ...query } = params
  const response = await axiosGet(`v1/league-analytics/${leagueId}`, query)
  return response.data
}

export const useGetLeagueAnalytics = (params: LeagueAnalyticsParams) => {
  return useQuery<LeagueAnalytics>(
    ['league-analytics', params.leagueId, params.startDate, params.endDate],
    () => getLeagueAnalytics(params),
    { enabled: !!params.leagueId },
  )
}
